import styled from "styled-components";

import Button from "@vfuk/core-button";
import Container from "@vfuk/core-container";
import { Icon } from "@vfuk/core-icon";

type NoResultsRowWithIconProps = {
  text: string;
  icon: string;
  addRecordBtnText: string;
  addRecord: () => void;
  showButton: boolean;
};

const NoResultsRowWithIconStyle = styled.div`
  text-align: center;
  line-height: 50px;
  padding: 50px;
`;

export const NoResultsRowWithIcon = ({
  text,
  icon,
  addRecordBtnText,
  addRecord,
  showButton,
}: NoResultsRowWithIconProps): JSX.Element => {
  return (
    <Container elevation paddingLevel={2}>
      <NoResultsRowWithIconStyle>
        <Icon name={icon} size={5} />
        <div>{text}</div>
        {showButton && (
          <Button
            text={addRecordBtnText}
            onClick={addRecord}
            appearance="secondary"
          />
        )}
      </NoResultsRowWithIconStyle>
    </Container>
  );
};
